module.exports = __webpack_public_path__ + "assets/a84083293d7b5ba239d5ccdd35dbae8e.jpg";